export default __webpack_public_path__ + "static/media/default_thumbnail_image.6e863fcd.jpg";